module.exports = __webpack_public_path__ + "img/dash1-light.72da629f.png";